module.exports = [
    {
        "idPrimary": 196730330,
        "idContent": "display_agent_1",
        "deleteField": false,
        "label": "Name",
        "data": "ACME Agent",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730331,
        "idContent": "display_agent_2",
        "deleteField": false,
        "label": "Title",
        "data": "Sales Associate",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730332,
        "idContent": "display_agent_3",
        "deleteField": false,
        "label": "Email",
        "data": "tes\u00f1@xpressdocs.com",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730333,
        "idContent": "display_agent_4",
        "deleteField": false,
        "label": "Phone 1",
        "data": "123.456.7654",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730334,
        "idContent": "display_agent_5",
        "deleteField": false,
        "label": "Phone 2",
        "data": "555.555.0123",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730335,
        "idContent": "display_agent_6",
        "deleteField": false,
        "label": "Phone 3",
        "data": "123-456-7890",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730336,
        "idContent": "display_agent_7",
        "deleteField": false,
        "label": "Website",
        "data": "www.xdocs.com",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730337,
        "idContent": "display_agent_8",
        "deleteField": false,
        "label": "Social Media",
        "data": "@socialmedia",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730338,
        "idContent": "display_branch_1",
        "deleteField": false,
        "label": "Line 1",
        "data": "Acme Demo Office",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730339,
        "idContent": "display_branch_2",
        "deleteField": false,
        "label": "Line 2",
        "data": "1301 NE Loop 820",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730340,
        "idContent": "display_branch_3",
        "deleteField": false,
        "label": "Line 3",
        "data": "Fort Worth, TX 76131",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730341,
        "idContent": "display_branch_4",
        "deleteField": false,
        "label": "Line 4",
        "data": "PH: 866.977.3627",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730342,
        "idContent": "display_branch_5",
        "deleteField": false,
        "label": "Line 5",
        "data": "OFF: 214-334-7745",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730343,
        "idContent": "display_branch_6",
        "deleteField": false,
        "label": "Website\/Line 6",
        "data": "xpressdocs.com",
        "align": null,
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730344,
        "idContent": "field_1",
        "deleteField": false,
        "label": "Headline (Back)",
        "data": "",
        "align": "",
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730345,
        "idContent": "field_2",
        "deleteField": false,
        "label": "Headline (Front):",
        "data": "",
        "align": "",
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730346,
        "idContent": "field_3",
        "deleteField": false,
        "label": "Description",
        "data": "",
        "align": "",
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730347,
        "idContent": "field_6",
        "deleteField": false,
        "label": "first field",
        "data": "",
        "align": "",
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730348,
        "idContent": "field_68",
        "deleteField": false,
        "label": "Call to Action:",
        "data": "",
        "align": "",
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    },
    {
        "idPrimary": 196730349,
        "idContent": "field_7",
        "deleteField": false,
        "label": "second field",
        "data": "",
        "align": "",
        "color": null,
        "dataLimitOverride": false,
        "font": null,
        "fontSize": null,
        "idComponent": null
    }
]
